"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionSetShowKeys = exports.actionChangeLang = exports.actionAddTranslations = void 0;
var _actionTypes = require("../actionTypes");
var actionAddTranslations = exports.actionAddTranslations = function actionAddTranslations(translations) {
  return {
    type: _actionTypes.ACTION_ADD_TRANSLATIONS,
    payload: {
      translations: translations
    }
  };
};
var actionChangeLang = exports.actionChangeLang = function actionChangeLang(lang) {
  return {
    type: _actionTypes.ACTION_CHANGE_LANG,
    payload: {
      lang: lang
    }
  };
};
var actionSetShowKeys = exports.actionSetShowKeys = function actionSetShowKeys(showKeys) {
  return {
    type: _actionTypes.ACTION_SET_SHOW_KEYS,
    payload: {
      showKeys: showKeys
    }
  };
};